import { render, staticRenderFns } from "./DormUserAccount.vue?vue&type=template&id=6b1133e9&scoped=true&"
import script from "./DormUserAccount.vue?vue&type=script&lang=js&"
export * from "./DormUserAccount.vue?vue&type=script&lang=js&"
import style0 from "./DormUserAccount.vue?vue&type=style&index=0&id=6b1133e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1133e9",
  null
  
)

export default component.exports